import FilterPanel from "components/partials/filter-panel/filter-panel";
import ColumnOptions from "components/partials/column-options/column-options";

import { useFiltersOnCampaignsTable } from "containers/admin/clients/client/campaigns-page/hooks/use-filters-on-campaigns-table";

import { FiltersStateOnTable } from "types/filters";
import { FiltersToApplyOnCampaignsPage } from "containers/admin/clients/client/campaigns-page/components/filters-on-campaigns-table/filters-on-campaigns-table.types";
import { UserTableLayout } from "hooks/api/use-user-layout";
import { ColumnOption } from "types/table";

interface FiltersOnCampaignsTableProps
  extends FiltersStateOnTable<FiltersToApplyOnCampaignsPage> {
  tableColumnsConfig: UserTableLayout;
  columnOptions: ColumnOption[];
  onToggleColumn: (columnId: string) => void;
  isFetching?: boolean;
}

const FiltersOnCampaignsTable = ({
  filtersToApply,
  setFiltersToApply,
  tableColumnsConfig,
  columnOptions,
  onToggleColumn,
  isFetching = false,
}: FiltersOnCampaignsTableProps) => {
  const { filtersToDisplay, currentFilters, handleFilterChange } = useFiltersOnCampaignsTable({
    filtersToApply,
    setFiltersToApply,
  });

  return (
    <>
      <FilterPanel
        filters={filtersToDisplay}
        currentFilters={currentFilters}
        onFilterChange={handleFilterChange}
        isFetching={isFetching}
      />

      <ColumnOptions
        tableConfigKey="campaigns"
        tableColumnsConfig={tableColumnsConfig}
        columnOptions={columnOptions}
        onToggleColumn={onToggleColumn}
      />
    </>
  );
};

export default FiltersOnCampaignsTable;
